<template>
    <div class="tab_wrapper font-responsive">
        <div class="tab_contents mobile:flex-column">
            <div class="tab_visual w-1/2 mobile:w-full">
                <div class="tab_photo-big">
                    <mid class="tab_photo-big--inner" v-if="tab.visual.slides" :component_data="{component:'slides', options:tab.visual.slides_options, images:tab.visual.slides, static_bg:tab.visual.img.src}"></mid>
                    <img class="tab_photo-big--inner" v-else :src="tab.visual.img.src" :alt="tab.visual.img.alt">
                    <video-block class="tab_video tab_video_r" v-if="tab.visual.video" :component_data="tab.visual.video"> </video-block>
                </div>
                <span class="tab_photo-big--sidenote" v-if="tab.visual.img.sidenote" v-html="tab.visual.img.sidenote"></span>
            </div>
            <article class="tab_caption w-2/5 mobile:w-full">
                <header>
                    <figure class="tab_icon" v-html="tab.icon" :style="customColor(tab)"></figure>
                    <h2 v-html="tab.title"></h2>
                </header>
                <div class="tab_texts">
                    <p v-for="(text, index) in texts(tab)" v-html="text" :key="index"></p>
                </div>
            </article>

        </div>
    </div>
</template>

<script>
import video from '@/components/videoBlock/video_no_thumb'

export default {
    props: ['component_data'],
    methods: {
      customColor(tab){
        if(tab.icon_color) {
          return "color: "+tab.icon_color+";"
        }
      },
    },
    data(){
        return {
            tab: {
                "title": "",
                "id": "",
                "icon": "",
                "text": "",
                "visual": {
                    "img": {
                        "src": "",
                        "alt": ""
                    },
                    "video": {
                        "src": "",
                        "alt": "",
                        "url": ""
                    }
                },
                "component": ""
            }
        }
    },
    mounted(){
        this.$nextTick(()=>{
            let visuals = Object.assign({}, this.tab.visual, this.component_data.visual)
            Object.assign(this.tab, this.component_data)
            this.tab.visual = visuals
        })
    },    
    components: {
        "video-block": video
    }
}
</script>

<style scoped>
    .tab_contents { /* text_left specific */
        flex-direction: row-reverse;
    }
    .tab_photo-big {
        margin-left: auto;
    }
    .tab_photo-big .tab_photo-big--inner {
        overflow:hidden;
        border-top-left-radius: 6em;
    }
    .tab_video {
        content: '';
        position: absolute;
        height: 8vw;
        width: 8vw;        
        bottom: 0;
        left: 0;
        z-index: 1;     
    }
    .tab_video {
        border-top-right-radius: 3em;
    }
    @media (max-width: 992px){
        .tab_video {
            height: 12.5vw;
            width: 12.5vw;
        }
    }
    @media (max-width: 768px){
        .tab_video {
            height: 15.5vw;
            width: 15.5vw;
        }
    }
    .tab_photo-big::before
    {
        content: '';
        border-bottom-right-radius: 3em;
        left: -3em;
        background: linear-gradient(to right, #AE0B11, #E41429);
    }
    @media (min-width: 1920px){
        .tab_photo-big {
            width: 620px;
            height: 680px;
        }     
    }
    .tab_wrapper::before { 
        border-top-left-radius: 6em;
        right: 0;
    }
    @media(max-width:992px){
        .tab_photo-big {
            margin: 0;
        }
    }
</style>
<style>
    .tab_video_r .avc_thumb_no_thumb {
        border-top-left-radius: 0em; 
        border-top-right-radius: 3em; 
        overflow: hidden;
        -webkit-box-shadow: 3px 3px 5px -1px rgba(0,0,0,0.1);
        -moz-box-shadow: 3px 3px 5px -1px rgba(0,0,0,0.1);
        box-shadow: 3px 3px 5px -1px rgba(0,0,0,0.1);
    }
</style>
